import React from 'react'
import { RouteObject } from 'react-router-dom'
import { UiProvider } from '@common/ui'
import App from './App'
import ErrorPage from './pages/ErrorPage'
import ListPage from './pages/entity/ListPage'
import EntityTypesPage from './pages/entity/EntityTypesPage'
import ImportPageRoute from './pages/entity/routes/ImportPageRoute'
import { ConfigurePageRoute } from './pages/entity/routes/ConfigurePageRoute'
import CreateOrEditPageRoute from './pages/entity/CreateOrEditPage'
import ViewEntityPageRoute from './pages/entity/ViewEntityPage'
import ViewEntityTypePage from './pages/entity/ViewEntityTypePage'
import {
  LegacyTypeEditRedirect,
  LegacyTypeNewRedirect,
  LegacyTypeViewRedirect,
} from './pages/entity/routes/LegacyTypeRedirects'
import PermissionGrantsListPageRoute from './pages/permission/PermissionGrantsListPage'
import CreateOrEditPermissionGrantPageRoute from './pages/permission/CreateOrEditPermissionGrantPage'
import AccessControlVisualizerPage from './pages/permission/AccessControlVisualizerPage'
import PermissionPoliciesListPageRoute from './pages/permission/PermissionPoliciesListPage'
import CreateOrEditPermissionPolicyPageRoute from './pages/permission/CreateOrEditPermissionPolicyPage'
import RegistryPage from './pages/registry/RegistryPage'
import AuditPage from './pages/audit/AuditPage'
import SemanticsPageRoute from './pages/semantics/SemanticsPage'
import SignInPage from './pages/signin/SignInPage'

const routeErrorElement = (
  <UiProvider>
    <ErrorPage />
  </UiProvider>
)

export const signinRoutes: RouteObject[] = [
  {
    path: '/signin',
    element: (
      <UiProvider>
        <SignInPage />
      </UiProvider>
    ),
    errorElement: routeErrorElement,
  },
]

export const mainRoutes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    errorElement: routeErrorElement,
    children: [
      {
        path: 'types',
        element: <EntityTypesPage />,
      },
      {
        path: 'types/new',
        element: <ConfigurePageRoute />,
      },
      {
        path: 'types/:entityTypeId',
        element: <ViewEntityTypePage />,
      },
      {
        path: 'types/:entityTypeId/edit',
        element: <ConfigurePageRoute />,
      },
      {
        path: 'entities/:entityTypeId',
        element: <ListPage />,
      },
      {
        path: 'entities/:entityTypeId/import',
        element: <ImportPageRoute />,
      },
      {
        path: 'entities/:entityTypeId/new',
        element: <CreateOrEditPageRoute />,
      },
      {
        path: 'entities/:entityTypeId/edit/:entityId',
        element: <CreateOrEditPageRoute />,
      },
      {
        path: 'entities/:entityTypeId/view/:entityId',
        element: <ViewEntityPageRoute />,
      },
      {
        path: 'entities/:entityTypeId/view',
        element: <LegacyTypeViewRedirect />,
      },
      {
        path: 'entities/:entityTypeId/edit',
        element: <LegacyTypeEditRedirect />,
      },
      {
        path: 'entities/new',
        element: <LegacyTypeNewRedirect />,
      },
      {
        path: 'access-control',
        element: <PermissionGrantsListPageRoute />,
      },
      {
        path: 'access-control/visualizer',
        element: <AccessControlVisualizerPage />,
      },
      {
        path: 'access-control/new',
        element: <CreateOrEditPermissionGrantPageRoute isEditMode={false} />,
      },
      {
        path: 'access-control/policies',
        element: <PermissionPoliciesListPageRoute />,
      },
      {
        path: 'access-control/policies/new',
        element: <CreateOrEditPermissionPolicyPageRoute isEditMode={false} />,
      },
      {
        path: 'access-control/policies/:policyId',
        element: <CreateOrEditPermissionPolicyPageRoute isEditMode />,
      },
      {
        path: 'access-control/:permissionGrantId',
        element: <CreateOrEditPermissionGrantPageRoute isEditMode />,
      },
      {
        path: 'semantics',
        element: <SemanticsPageRoute />,
      },
      {
        path: 'registry',
        element: <RegistryPage />,
      },
      {
        path: 'audit',
        element: <AuditPage />,
      },
    ],
  },
]
